/**
 * Panel bilgisi sarmalayıcıları — SUNUCU ALANINI OKUR (görev OL tur 2).
 *
 * NEDEN DEĞİŞTİ: sipariş yanıtları artık ham yükü (`rawPayload`) yöneticiden alıyor; ham
 * yükten türetilen bilgiler SUNUCUDA hesaplanıp yanıtla geliyor:
 *   - tekil yanıt: `panelFields` (PanelField[])
 *   - liste yanıtı : `noteSummary` (string | null)
 *
 * Bu dosya yalnız o alanları okur. Türetme mantığı `packages/shared/src/panel-fields.ts`te
 * DURUR ve API tarafında çalışır; panel ham yükten ikinci bir kez türetmez (eski türetme
 * kalırsa ham yük istemciye sızardı — sunucunun kırptığı alan panelde geri gelirdi).
 */
import type { PanelField } from '@aquabox/shared';
import type { Order } from '../api/types';

export type { PanelField };

/**
 * Sipariş detayının "Panel bilgisi" satırları — SUNUCUDAN gelir.
 * Sunucu alanı yoksa (eski sunucu) boş dizi döner.
 */
export function panelFields(order: Order): PanelField[] {
  return order.panelFields ?? [];
}

/**
 * Sipariş listesindeki not ikonunun metni — SUNUCUDAN gelir.
 * Sunucu alanı yoksa (eski sunucu) null döner.
 */
export function orderNoteSummary(order: Order): string | null {
  return order.noteSummary ?? null;
}
